// Telegram invite link used by the landing page CTAs and the auto-redirect.
export const telegramUrl = "https://t.me/+aS04d2tPE8wyNGU1";
